import Intro from 'components/Intro'
import About from 'components/About'
import NftSlider from 'components/NftSlider'
import RoadMap from 'components/RoadMap'
import Rewards from 'components/Rewards'
import Team from "components/OurTeam";
import Faq from "components/Faq";

const Home = () => {
    return (
        <main>
            <Intro />
            <About />
            <NftSlider/>
            <RoadMap />
            <Rewards />
            <Faq />
            <Team />
        </main>
    )
}

export default Home

